import { render } from "./Stats.vue?vue&type=template&id=bca7dfa6"
const script = {}
script.render = render

export default script